/*    
<summary>
   This class component is all about Managing general data functionality.
   Developer:Aashish Singh, Created Date:29-August-2023
</summary>
<param>No Parameter Passed</param>
<returns>Returns class instance</returns>
*/
import { action, computed, makeObservable, observable } from "mobx";
import toast from "react-hot-toast";
import URLConstants from "../../constants/url-constants";
import {
  IObservableInitialState,
  IOption,
  IOptionShiftSchedule,
} from "../../models/ICommon";
import IApiResponse, {
  IApiSuccessResponse,
} from "../../models/response/IApiResponse";
import {
  IBusinessSettingVM,
  IBusinessTypeVM,
  IConsumptionTaxVM,
  IMiscellaneousSettingVM,
  IMotivationInStoreVM,
  IMotivationVM,
  IPaymentInStoreVM,
  IPaymentVM,
  IReservationSettingVM,
  IStaffOption,
  IStoreOption,
  ITaxTypeVM,
  ITimeTypeVM,
} from "../../models/response/IMasterManagementResponse";
import { ICommonState } from "../../models/state/ICommonState";
import {
  IBusinessTypeState,
  IConsumptionTaxState,
  IMotivationInStoreState,
  IMotivationState,
  IPaymentInStoreState,
  IPaymentState,
  IReservationState,
  ITaxState,
  ITimeState,
} from "../../models/state/IMasterSettingsState";
import { formatMessage } from "../../translations/format-message";
import {
  businessTypeInitialState,
  consumptionTaxInitialState,
  motivationInitialState,
  motivationInStoreInitialState,
  paymentInitialState,
  paymnetInStoreInitialState,
  reservationSettingInitialState,
  taxInitialState,
  timeInitialState,
} from "../initialState/master-settings-state";
import * as baseService from "../service/base-service";
import dayjs from "dayjs";
import {
  IPaymentDetailsVMs,
  IPaymentSMRVM,
  IStoreSeletedPaymentList,
} from "../../models/response/ISMRResponse";
import {
  getBusinessTypeIdFromLocalStorage,
  getUserTypeFromLocalStorage,
} from "../../helpers/localstorage-helper";
import moment from "moment";
import userTypeEnum from "../../constants/enums/user-type-enum";
import demoStoreIcon from "../../assets/Images/teamwork.png";
import demoStoreManIcon from "../../assets/Images/man.png";
import demoStoreWomanIcon from "../../assets/Images/woman.png";
import { BusinessVM } from "../../models/response/IShiftManagementResponse";

export class MasterManagementStore implements ICommonState {
  inProgress = false;
  error = "";

  initialStateValue: IObservableInitialState = {
    success: false,
    error: "",
    inProgress: false,
  };

  storeOptionsState: IObservableInitialState = {
    success: false,
    error: "",
    inProgress: false,
  };
  staffOptionsState: IObservableInitialState = {
    success: false,
    error: "",
    inProgress: false,
  };

  // time settings state
  timeSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  addUpdateTimeSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  deleteTimeSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };
  storeOptionsForStaffState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  getByIdTimeSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  // tax srtting state
  taxSettingState: IObservableInitialState = { ...this.initialStateValue };

  addUpdateTaxSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  deleteTaxSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  getByIdTaxSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  // business type settings states
  businessTypeSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  addUpdateBusinessTypeSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  deleteBusinessTypeSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  getByIdBusinessTypeSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  // consumption tax states
  consumptionTaxState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  addUpdateConsumptionTaxState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  deleteConsumptionTaxState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  getByIdConsumptionTaxState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  // motivation setting states
  motivationSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  addUpdateMotivationSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  deleteMotivationSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  getByIdMotivationSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  // Motivation In Store States

  motivationInStoreState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  addUpdateMotivationInStoreState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  deleteMotivationInStoreState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  getByIdMotivationInStoreState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  // payment settings states

  paymentSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  addUpdatePaymentSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  deletePaymentSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  getByIdPaymentSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  // payment in store settings

  paymentInStoreState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  addUpdatePaymentInStoreState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  deletePaymentInStoreState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  getByIdPaymentInStoreState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  paymentDetailBySaleRecordIdState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  paymentDetailBySaleRecordId: IPaymentSMRVM = {
    Total: 0,
    ConsumptionTax: 0,
    PaymentDetailsVMs: [],
    StoreSeletedPayments: [],
  };

  // reservation setting states
  reservationSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  addUpdateReservationSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  deleteReservationSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  getByIdReservationSettingState: IObservableInitialState = {
    ...this.initialStateValue,
  };

  reservationSettingMinMax: any = undefined;
  reservationSettingMinMaxState = { ...this.initialStateValue };

  timeSetting: ITimeState = { ...timeInitialState };
  timeList: ITimeTypeVM[] = [];
  taxSetting: ITaxState = { ...taxInitialState };
  taxList: ITaxTypeVM[] = [];
  businessTypeSetting: IBusinessTypeState = { ...businessTypeInitialState };
  businessTypeList: IBusinessTypeVM[] = [];

  consumptioTaxSetting: IConsumptionTaxState = {
    ...consumptionTaxInitialState,
  };
  consumptionTaxList: IConsumptionTaxVM[] = [];

  motivationSetting: IMotivationState = { ...motivationInitialState };
  motivationList: IMotivationVM[] = [];

  motivationInStore: IMotivationInStoreState = {
    ...motivationInStoreInitialState,
  };
  motivationInStoreList: IMotivationInStoreVM[] = [];

  paymentSetting: IPaymentState = { ...paymentInitialState };
  paymentList: IPaymentVM[] = [];

  paymentInStore: IPaymentInStoreState = { ...paymnetInStoreInitialState };
  paymentInStoreList: IPaymentInStoreVM[] = [];

  reservationSetting: IReservationState = { ...reservationSettingInitialState };
  reservationList: IReservationSettingVM[] = [];
  
  allBusinessType: IBusinessTypeVM[] = [];
  allStoreOption: IStoreOption[] = [];
  allStoreOptionForStaff: IStoreOption[] = [];
  allStoreOptionForStaffUpdate: IStoreOption[] = [];
  allTaxOptions: ITaxTypeVM[] = [];
  allStaffOption: IStaffOption[] = [];
  getMiscellaneousSettingByKeyState: IObservableInitialState = { ...this.initialStateValue };
  getMiscellaneousSettingByKey: IMiscellaneousSettingVM | undefined = undefined;
  updateMiscellaneousSettingByKeyState: IObservableInitialState = { ...this.initialStateValue };

  reservationSettingBusinessVM: BusinessVM[] = [];

  disableAction: boolean = false;
  
  constructor() {
    makeObservable(this, {
      inProgress: observable,
      error: observable,
      storeOptionsState: observable,
      allBusinessType: observable,
      allTaxOptions: observable,
      allStoreOption: observable,
      allStaffOption: observable,
      staffOptionsState: observable,
      timeSettingState: observable,
      reservationSettingMinMax: observable,
      reservationSettingMinMaxState: observable,
      addUpdateTimeSettingState: observable,
      deleteTimeSettingState: observable,
      getByIdTimeSettingState: observable,
      timeSetting: observable,
      timeList: observable,
      taxSettingState: observable,
      addUpdateTaxSettingState: observable,
      deleteTaxSettingState: observable,
      getByIdTaxSettingState: observable,
      taxSetting: observable,
      taxList: observable,
      businessTypeSettingState: observable,
      addUpdateBusinessTypeSettingState: observable,
      deleteBusinessTypeSettingState: observable,
      getByIdBusinessTypeSettingState: observable,
      businessTypeSetting: observable,
      businessTypeList: observable,
      allStoreOptionForStaff: observable,
      motivationSettingState: observable,
      addUpdateMotivationSettingState: observable,
      deleteMotivationSettingState: observable,
      getByIdMotivationSettingState: observable,
      motivationSetting: observable,
      motivationList: observable,

      motivationInStoreState: observable,
      addUpdateMotivationInStoreState: observable,
      deleteMotivationInStoreState: observable,
      getByIdMotivationInStoreState: observable,
      motivationInStore: observable,
      motivationInStoreList: observable,

      getByIdPaymentSettingState: observable,
      paymentSetting: observable,
      paymentList: observable,
      addUpdatePaymentSettingState: observable,
      deletePaymentSettingState: observable,
      paymentSettingState: observable,

      getByIdPaymentInStoreState: observable,
      paymentDetailBySaleRecordIdState: observable,
      paymentDetailBySaleRecordId: observable,
      paymentInStore: observable,
      paymentInStoreList: observable,
      addUpdatePaymentInStoreState: observable,
      deletePaymentInStoreState: observable,
      paymentInStoreState: observable,

      reservationSettingBusinessVM: observable,
      reservationSettingState: observable,
      addUpdateReservationSettingState: observable,
      deleteReservationSettingState: observable,
      getByIdReservationSettingState: observable,
      reservationSetting: observable,
      reservationList: observable,
      storeOptionsForStaffState: observable,

      consumptionTaxState: observable,
      addUpdateConsumptionTaxState: observable,
      deleteConsumptionTaxState: observable,
      getByIdConsumptionTaxState: observable,
      consumptioTaxSetting: observable,
      consumptionTaxList: observable,
      allStoreOptionForStaffUpdate: observable,
      getMiscellaneousSettingByKeyState: observable,
      getMiscellaneousSettingByKey: observable,
      updateMiscellaneousSettingByKeyState: observable,

      disableAction: observable,

      GetAllBusinessTypeService: action,
      GetAllStoreOptionService: action,
      GetAllTaxOptionService: action,
      reset: action,
      resetStore: action,
      GetAllTimeService: action,
      AddTimeService: action,
      UpdateTimeService: action,
      DeleteTimeService: action,
      GetTimeByIdService: action,
      GetAllTaxService: action,
      AddTaxService: action,
      UpdateTaxService: action,
      DeleteTaxService: action,
      GetTaxByIdService: action,
      GetAllBusinessTypeListService: action,
      AddBusinessTypeService: action,
      UpdateBusinessTypeService: action,
      DeleteBusinessTypeService: action,
      GetBusinessTypeByIdService: action,
      GetReservationSettingMinMaxTime: action,
      GetAllStaffOptionServiceByReservationDateStoreId: action,
      GetAllStaffOptionServiceByStoreIdBooking: action,
      resetAddUpdateBusinessTypeSettingState: action,
      resetGetByIdBusinessTypeSettingState: action,
      resetGetAllBusinessTypeSettingState: action,

      AddConsumptionTaxService: action,
      UpdateConsumptionTaxService: action,
      GetConsumptionTaxByHeadquarterIdService: action,
      resetAddUpdateConsumptionTaxState: action,

      GetAllMotivationService: action,
      AddMotivationService: action,
      UpdateMotivationService: action,
      DeleteMotivationService: action,
      GetMotivationByIdService: action,
      resetAddUpdateMotivationSettingState: action,
      resetGetByIdMotivationSettingState: action,
      resetGetAllMotivationSettingState: action,
      
      AddStoreMotivation: action,
      DeleteStoreMotivation: action,
      GetStoreMotivationByStoreId: action,
      resetdDeleteMotivationInStoregState: action,
      resetAddUpdateMotivationInStoreState: action,

      GetMiscellaneousSettingByKeyService: action,
      UpdateMiscellaneousSettingService: action,
      
      GetAllPaymentService: action,
      GetStorePaymentByStoreId: action,
      GetSMRPaymentDetailsBySaleRecordId: action,
      AddPaymentService: action,
      UpdatePaymentService: action,
      DeletePaymentService: action,
      GetPaymentByIdService: action,
      resetAddUpdatePaymentSettingState: action,
      GetAllStoreOptionForStaffService: action,
      resetGetByIdPaymentSettingState: action,
      resetGetAllPaymentSettingState: action,
      resetPaymentDetailBySaleRecordIdState: action,
      resetReservationSettingMinMaxState: action,
      
      resetGetMiscellaneousSettingByKeyState: action,
      resetUpdateMiscellaneousSettingByKeyState: action,
      AddReservationSettingService: action,
      UpdateReservationSettingService: action,
      GetReservationSettingByIdService: action,
      GetAllStaffOptionServiceByStoreId: action,
      resetAddUpdateReservationSettingState: action,
      setDisableAction: action,
      getAllBusinessTypes: computed,
      getAllTimeList: computed,
      getAllTaxList: computed,
      getAllBusinessTypeList: computed,
      getAllTaxOptions: computed,
      getAllTimeOptions: computed,
      getAllStoreOptions: computed,
      getAllStoreOptionsForInventory: computed,
      getBusinessTypeDetail: computed,
      getAllStoreOptionsAll: computed,
      getReservationSettingDetail: computed,
      getAllStaffOptions: computed,
      getAllStaffOptionsWithSelectStaff: computed,
      getAllStaffOptionsWithAll: computed,
      getAllStaffOptionsForBooking: computed,
      getAllConsumptionTaxList: computed,
      getConsumptionTaxDetail: computed,
      PaymentInStoreDetails: computed,
      PaymentThatAreUsedInStoreDetails: computed,
      getMotivationInStoreOptions: computed,
      getAllStoreOptionsAllForStaff: computed,
      storeSeletedPaymentModesForSMR: computed,
      getAllStoreOptionsForStaff: computed,
      getReservationSettingMinMaxDetail: computed,
      getAllStoreOptionsForStaffUpdate: computed,
      getClosedDays: computed,
      getMiscellaneousSettingByKeyDetail: computed,
    });
  }

  /**
   * This function is used to Get All Generals List data with pagination information by calling an API.
   * @returns
   */
  GetAllBusinessTypeService = () => {
    this.inProgress = true;
    const url = URLConstants.MasterManagement + "/BuisnessType/All";
    return baseService
      .getRequest(url)
      .then(
        (response: IApiResponse<IApiSuccessResponse<IBusinessTypeVM[]>>) => {
          if (response.data.Error) {
            this.error = response.data.Message;
            toast.error(formatMessage(response.data.Message));
          } else {
            this.allBusinessType = response.data.Data;
          }
        }
      )
      .catch((err: string) => {
        this.error = err;
      })
      .finally(
        action(() => {
          this.inProgress = false;
        })
      );
  };

  /**
   * This function is used to map allBusinessType to allGeneral List suitable for Grid Component.
   * @returns getAllBusinessTypes
   */
  get getAllBusinessTypes(): IOption[] {
    const options: IOption[] = [
      {
        id: -1,
        value: "please_select",
        disabled: false,
      },
    ];
    if (this.allBusinessType && this.allBusinessType?.length > 0)
      this.allBusinessType.map((businessType: IBusinessTypeVM) => {
        options.push({
          id: businessType.Id,
          value: businessType.TypeName,
          disabled: false,
        });
      });
    return options;
  }

  get getAllBusinessTypesAll(): IOption[] {
    const options: IOption[] = [
      {
        id: -1,
        value: formatMessage("all_business_type"),
        disabled: false,
      },
    ];
    if (this.allBusinessType && this.allBusinessType?.length > 0)
      this.allBusinessType.map((businessType: IBusinessTypeVM) => {
        options.push({
          id: businessType.Id,
          value: businessType.TypeName,
          disabled: false,
        });
      });
    return options;
  }
  /**
   * This function is used to Get All Generals List data with pagination information by calling an API.
   * @returns
   */
  GetAllTaxOptionService = (businessTypeId?: number) => {
    this.inProgress = true;
    const url =
      URLConstants.MasterManagement +
      "/TaxType/All?BusinessTypeId=" +
      (businessTypeId && Number(businessTypeId) > 0
        ? businessTypeId
        : getBusinessTypeIdFromLocalStorage());
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<ITaxTypeVM[]>>) => {
        if (response.data.Error) {
          this.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.allTaxOptions = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.error = err;
      })
      .finally(
        action(() => {
          this.inProgress = false;
        })
      );
  };

  /**
   * This function is used to map allTaxOptions to allGeneral List suitable for Grid Component.
   * @returns getAllTaxOptions
   */
  get getAllTaxOptions(): IOption[] {
    const options: IOption[] = [
      {
        id: -1,
        value: "please_select",
        disabled: false,
      },
    ];
    if (this.allTaxOptions && this.allTaxOptions?.length > 0)
      this.allTaxOptions.map((taxOption: ITaxTypeVM) => {
        options.push({
          id: taxOption.Id,
          value: taxOption.TaxValue?.toString(),
          disabled: false,
        });
      });
    return options;
  }

  /**
   * This function is used to Get All store List data  information by calling an API.
   * @returns
   */

  GetAllStoreOptionService = () => {
    this.storeOptionsState.inProgress = true;
    const urlParams = new URLSearchParams();
    let businessTypeId = getBusinessTypeIdFromLocalStorage();
    let userType = getUserTypeFromLocalStorage();
    if (
      businessTypeId > 0 &&
      userType !== userTypeEnum[userTypeEnum.Customer]
    ) {
      urlParams.append("BusinessTypeId", String(businessTypeId));
    }
    const url = URLConstants.StoreManagement + "/All?" + urlParams.toString();
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IStoreOption[]>>) => {
        if (response.data.Error) {
          this.storeOptionsState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.storeOptionsState.success = true;
          this.allStoreOption = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.storeOptionsState.error = err;
      })
      .finally(
        action(() => {
          this.storeOptionsState.inProgress = false;
        })
      );
  };

  GetAllStoreOptionForStaffService = (userId?: number) => {
    this.storeOptionsForStaffState.inProgress = true;
    const urlParams = new URLSearchParams();
    let businessTypeId = getBusinessTypeIdFromLocalStorage();
    let userType = getUserTypeFromLocalStorage();
    if (businessTypeId > 0)
      urlParams.append("BusinessTypeId", String(businessTypeId));

    if (userId && userId > 0 && userType === userTypeEnum[userTypeEnum.Staff])
      urlParams.append("UserId", String(userId));
    if (
      userId &&
      userId > 0 &&
      userType !== userTypeEnum[userTypeEnum.SuperAdmin]
    )
      urlParams.append("UserId", String(userId));

    const url = URLConstants.StoreManagement + "/All?" + urlParams.toString();
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IStoreOption[]>>) => {
        if (response.data.Error) {
          this.storeOptionsForStaffState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.storeOptionsForStaffState.success = true;
          if (userId && userId > 0) {
            this.allStoreOptionForStaffUpdate = response.data.Data;
          } else {
            this.allStoreOptionForStaff = response.data.Data;
          }
        }
      })
      .catch((err: string) => {
        this.storeOptionsForStaffState.error = err;
      })
      .finally(
        action(() => {
          this.storeOptionsForStaffState.inProgress = false;
        })
      );
  };

  /**
   * This function is used to map allTaxOptions to allGeneral List suitable for Grid Component.
   * @returns getAllTaxOptions
   */
  get getAllStoreOptions(): IOption[] {
    const options: IOption[] = [
      {
        id: -1,
        value: "please_select",
        disabled: false,
      },
    ];

    if (this.allStoreOption && this.allStoreOption.length > 0) {
      this.allStoreOption.map((storeOption: IStoreOption) => {
        options.push({
          id: storeOption.Id,
          value: storeOption.StoreName,
          disabled: false,
          data: { IsNominationFee: storeOption.IsNominationFee },
        });
      });
    }
    return options;
  }
  get getAllStoreOptionsForInventory(): IOption[] {
    const options: IOption[] = [
      {
        id: -1,
        value: "select_store",
        disabled: false,
      },
    ];

    if (this.allStoreOption && this.allStoreOption.length > 0) {
      this.allStoreOption.map((storeOption: IStoreOption) => {
        options.push({
          id: storeOption.Id,
          value: storeOption.StoreName,
          disabled: false,
          data: { IsNominationFee: storeOption.IsNominationFee },
        });
      });
    }
    return options;
  }
  get getAllStoreOptionsForStaff(): IOption[] {
    const options: IOption[] = [
      {
        id: -1,
        value: "please_select",
        disabled: false,
      },
    ];

    if (this.allStoreOptionForStaff && this.allStoreOptionForStaff.length > 0) {
      this.allStoreOptionForStaff.map((storeOption: IStoreOption) => {
        options.push({
          id: storeOption.Id,
          value: storeOption.StoreName,
          disabled: false,
          data: { IsNominationFee: storeOption.IsNominationFee },
        });
      });
    }
    return options;
  }
  get getAllStoreOptionsForStaffUpdate(): IOption[] {
    const options: IOption[] = [
      {
        id: -1,
        value: "please_select",
        disabled: false,
      },
    ];

    if (
      this.allStoreOptionForStaffUpdate &&
      this.allStoreOptionForStaffUpdate.length > 0
    ) {
      this.allStoreOptionForStaffUpdate.map((storeOption: IStoreOption) => {
        options.push({
          id: storeOption.Id,
          value: storeOption.StoreName,
          disabled: false,
          data: { IsNominationFee: storeOption.IsNominationFee },
        });
      });
    }
    return options;
  }

  get getAllStoreOptionsAll(): IOption[] {
    const options: IOption[] = [
      {
        id: -1,
        value: "all_stores",
        disabled: false,
      },
    ];
    if (this.allStoreOption && this.allStoreOption?.length > 0)
      this.allStoreOption.map((storeOption: IStoreOption) => {
        options.push({
          id: storeOption.Id,
          value: storeOption.StoreName,
          disabled: false,
        });
      });
    return options;
  }
  get getAllStoreOptionsAllForStaff(): IOption[] {
    const options: IOption[] = [
      {
        id: -1,
        value: "all_stores",
        disabled: false,
      },
    ];
    if (this.allStoreOptionForStaff && this.allStoreOptionForStaff?.length > 0)
      this.allStoreOptionForStaff.map((storeOption: IStoreOption) => {
        options.push({
          id: storeOption.Id,
          value: storeOption.StoreName,
          disabled: false,
        });
      });
    return options;
  }

  GetAllStaffOptionServiceByStoreId = (storeId: number, isCustomerLogin = false, headquarterId: null | number = null) => {
    this.staffOptionsState.inProgress = true;
      const urlParams = new URLSearchParams();
      
      if(headquarterId && headquarterId > 0)
        urlParams.append("headquarterId", String(headquarterId));
      if(storeId > 0)
        urlParams.append("storeId", String(storeId));
      urlParams.append("isCustomerLogin", String(isCustomerLogin));
    const url = URLConstants.GetAllStaffByStoreId + "?" + urlParams.toString();
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IStaffOption[]>>) => {
        if (response.data.Error) {
          this.staffOptionsState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.staffOptionsState.success = true;
          this.allStaffOption = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.staffOptionsState.error = err;
      })
      .finally(
        action(() => {
          this.staffOptionsState.inProgress = false;
        })
      );
  };

  GetAllStaffOptionServiceByStoreIdBooking = (storeId: number, isCustomerLogin = true) => {
    this.staffOptionsState.inProgress = true;
    const url = URLConstants.GetAllStaffByStoreId + "?storeId=" + storeId + "&isCustomerLogin="+isCustomerLogin;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IStaffOption[]>>) => {
        if (response.data.Error) {
          this.staffOptionsState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.staffOptionsState.success = true;
          this.allStaffOption = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.staffOptionsState.error = err;
      })
      .finally(
        action(() => {
          this.staffOptionsState.inProgress = false;
        })
      );
  };

  GetAllStaffOptionServiceByReservationDateStoreId = (
    storeId: number,
    Date: string,
    endDate?: string
  ) => {
    this.staffOptionsState.inProgress = true;
    const url =
      URLConstants.GetAllStaffReservationDateTime +
      "?StoreId=" +
      storeId +
      "&Date=" +
      Date +
      "&endDate=" +
      endDate;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IStaffOption[]>>) => {
        if (response.data.Error) {
          this.staffOptionsState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.staffOptionsState.success = true;
          this.allStaffOption = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.staffOptionsState.error = err;
      })
      .finally(
        action(() => {
          this.staffOptionsState.inProgress = false;
        })
      );
  };

  /**
   * This function is used to map allTaxOptions to allGeneral List suitable for Grid Component.
   * @returns getAllTaxOptions
   */
  get getAllStaffOptions(): IOptionShiftSchedule[] {
    const options: IOptionShiftSchedule[] = [];

    if (this.allStaffOption && this.allStaffOption.length > 0) {
      this.allStaffOption.map((storeOption: IStaffOption) => {
        options.push({
          id: storeOption.Id,
          value: storeOption.StaffName,
          label: storeOption.StaffName,
          disabled: false,
          data: { ...storeOption },
        });
      });
    }
    return options;
  }
  get getAllStaffOptionsWithSelectStaff(): IOptionShiftSchedule[] {
    const options: IOptionShiftSchedule[] = [{id: -1, value: "staff_selection", label: "staff_selection", disabled: false }];

    if (this.allStaffOption && this.allStaffOption.length > 0) {
      this.allStaffOption.map((storeOption: IStaffOption) => {
        options.push({
          id: storeOption.Id,
          value: storeOption.StaffName,
          label: storeOption.StaffName,
          disabled: false,
          data: { ...storeOption },
        });
      });
    }
    return options;
  }
  get getAllStaffOptionsWithAll(): IOptionShiftSchedule[] {
    const options: IOptionShiftSchedule[] = [{
      id: -1,
      value: formatMessage("all_staff"),
      label: formatMessage("all_staff"),
      disabled: false,
      data: {
        Id: -1,
        StaffName: "",
        Image: "",
        Expertise: "",
        NominationFee: 0,
        IsNominationFee: false,
      },
    }];

    if (this.allStaffOption && this.allStaffOption.length > 0) {
      this.allStaffOption.map((storeOption: IStaffOption) => {
        options.push({
          id: storeOption.Id,
          value: storeOption.StaffName,
          label: storeOption.StaffName,
          disabled: false,
          data: { ...storeOption },
        });
      });
    }
    return options;
  }
  get getAllStaffOptionsForBooking() {
    const options = [
      {
        Id: -3,
        Image: demoStoreIcon,
        Name: formatMessage("no_nomination"),
        Available: true,
        Expertise: "",
        NominationFee: 0,
        IsNominationFee: false,
      },
      {
        Id: -2,
        Image: demoStoreWomanIcon,
        Name: formatMessage("women_hope"),
        Available: true,
        Expertise: "",
        NominationFee: 0,
        IsNominationFee: false,
      },
      {
        Id: -1,
        Image: demoStoreManIcon,
        Name: formatMessage("male_hope"),
        Available: true,
        Expertise: "",
        NominationFee: 0,
        IsNominationFee: false,
      },
    ];

    if (this.allStaffOption && this.allStaffOption.length > 0) {
      this.allStaffOption.map((storeOption: IStaffOption) => {
        options.push({
          Id: storeOption.Id,
          Image: storeOption.Image,
          Name: storeOption.StaffName,
          Available: true,
          Expertise: storeOption.Expertise,
          NominationFee: storeOption.NominationFee,
          IsNominationFee: storeOption.IsNominationFee,
        });
      });
    }
    return options;
  }

  GetAllTimeService = (businessTypeId?: number) => {
    this.timeSettingState.inProgress = true;
    const url =
      URLConstants.MasterManagement +
      "/Time/All?BusinessTypeId=" +
      (businessTypeId && businessTypeId > 0
        ? businessTypeId
        : getBusinessTypeIdFromLocalStorage());
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<ITimeTypeVM[]>>) => {
        if (response.data.Error) {
          this.timeSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.timeSettingState.success = true;
          this.timeList = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.timeSettingState.error = err;
      })
      .finally(
        action(() => {
          this.timeSettingState.inProgress = false;
        })
      );
  };

  /**
   * This function is used to map allTimeList to allGeneral List suitable for Grid Component.
   * @returns getAllTimeOptions
   */
  get getAllTimeOptions(): IOption[] {
    const options: IOption[] = [
      {
        id: -1,
        value: "please_select",
        disabled: false,
      },
    ];
    if (this.timeList && this.timeList.length > 0)
      this.timeList.map((timeOption: ITimeTypeVM) => {
        const timeInMinutes = timeOption.Time;
        options.push({
          id: timeOption.Id,
          value: `${timeInMinutes.toString()}`,

          disabled: false,
        });
      });
    return options;
  }

  /**
   * This function is used to map allTaxOptions to allGeneral List suitable for Grid Component.
   * @returns getAllTaxOptions
   */

  get getAllTimeList(): any[] {
    if (this.timeList && this.timeList.length > 0) {
      return this.timeList.map((time) => ({
        ...time,
        Time: `${time.Time}`,
      }));
    }
    return [];
  }

  AddTimeService = (data: any) => {
    let finalData = {
      Time: data.Time,
      Description: data.Description,
      BusinessTypeId: getBusinessTypeIdFromLocalStorage(),
    };

    const timeExists = this.timeList.find((time) => {
      if (
        parseInt(time.Time?.toString()) ===
        parseInt(finalData.Time?.toString())
      ) {
        this.addUpdateTaxSettingState.error = "time_already_exists";
        return true;
      }
      return false;
    });

    if (timeExists) {
      toast.error(formatMessage("time_already_exists"));
      return;
    }

    const url = URLConstants.MasterManagement + "/Time";
    this.addUpdateTimeSettingState.inProgress = true;
    return baseService
      .postRequest(url, finalData)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateTimeSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdateTimeSettingState.success = true;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.addUpdateTimeSettingState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateTimeSettingState.inProgress = false;
        })
      );
  };

  /**
   * This function is used to Updating Existing StoreManagement Details by calling an API.
   * @param id : The StoreManagement Identifier
   * @param data
   * @returns
   */
  UpdateTimeService = (id: number, data: any) => {
    const url = URLConstants.MasterManagement + "/Time";
    const finalData = {
      Id: id,
      Time: data.Time,
      Description: data.Description,
      BusinessTypeId: getBusinessTypeIdFromLocalStorage(),
      IsTimeUpdated: data.IsTimeUpdated,
    };

    const timeExists = this.timeList.find((time) => {
      if (
        parseInt(time.Time?.toString()) ===
        parseInt(finalData.Time?.toString()) &&
        time.Id !== id
      ) {
        this.addUpdateTaxSettingState.error = "time_already_exists";
        return true;
      }
      return false;
    });

    if (timeExists) {
      toast.error(formatMessage("time_already_exists"));
      return;
    }

    return baseService
      .putRequest(url, finalData)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateTimeSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdateTimeSettingState.success = true;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.addUpdateTimeSettingState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateTimeSettingState.inProgress = false;
        })
      );
  };

  GetTimeByIdService = (id: number) => {
    this.getByIdTimeSettingState.inProgress = true;
    let url = `${URLConstants.MasterManagement}/Time/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.getByIdTimeSettingState.error = response.data.Message;
        } else {
          let data = response.data.Data;
          this.timeSetting = {
            Time: data.Time,
            Id: data.Id,
            Description: data.Description,
          };
        }
      })
      .catch((err: string) => {
        this.getByIdTimeSettingState.error = err;
      })
      .finally(
        action(() => {
          this.getByIdTimeSettingState.inProgress = false;
        })
      );
  };

  get getTimeDetail(): ITimeState {
    if (this.timeSetting) {
      return {
        Id: this.timeSetting.Id || -1,
        Time: this.timeSetting.Time || "",
        Description: this.timeSetting.Description || "",
      };
    }
    return timeInitialState;
  }

  /*
    This function is used to reset all AddStoreManagement observables to their initial values.  
    */
  resetAddUpdateTimeSettingState = () => {
    this.addUpdateTimeSettingState.inProgress = false;
    this.addUpdateTimeSettingState.success = false;
    this.addUpdateTimeSettingState.error = "";
    this.timeSetting = timeInitialState;
  };

  resetGetByIdTimeSettingState = () => {
    this.getByIdTimeSettingState.inProgress = false;
    this.getByIdTimeSettingState.success = false;
    this.getByIdTimeSettingState.error = "";
    this.timeSetting = timeInitialState;
  };

  resetGetAllTimeSettingState = () => {
    this.timeSettingState.inProgress = false;
    this.timeSettingState.success = false;
    this.timeSettingState.error = "";
    this.timeSetting = timeInitialState;
  };

  /**
   * This function is used to Delete StoreManagement by calling an API.
   * @param id : The StoreManagement Identifier
   * @returns
   */
  DeleteTimeService = (id: number) => {
    this.deleteTimeSettingState.inProgress = true;
    let url = `${URLConstants.MasterManagement}/Time/${id}`;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteTimeSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else this.deleteTimeSettingState.success = true;
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.deleteTimeSettingState.error = err;
      })
      .finally(
        action(() => {
          this.deleteTimeSettingState.inProgress = false;
        })
      );
  };

  resetdDeleteTimeSettingState = () => {
    this.deleteTimeSettingState.inProgress = false;
    this.deleteTimeSettingState.success = false;
    this.deleteTimeSettingState.error = "";
  };

  GetAllTaxService = () => {
    this.taxSettingState.inProgress = true;
    const url =
      URLConstants.MasterManagement +
      "/TaxType/All?BusinessTypeId=" +
      getBusinessTypeIdFromLocalStorage();
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<ITaxTypeVM[]>>) => {
        if (response.data.Error) {
          this.taxSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.taxSettingState.success = true;
          this.taxList = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.taxSettingState.error = err;
      })
      .finally(
        action(() => {
          this.taxSettingState.inProgress = false;
        })
      );
  };

  /**
   * This function is used to map allTaxOptions to allGeneral List suitable for Grid Component.
   * @returns getAllTaxOptions
   */
  get getAllTaxList(): any[] {
    if (this.taxList && this.taxList.length > 0) {
      return this.taxList.map((tax) => ({
        ...tax,
        TaxValue: `${tax.TaxValue}%`,
      }));
    }
    return [];
  }

  AddTaxService = (data: any) => {
    let finalData = {
      TaxValue: data.TaxValue,
      Description: data.Description,
      BusinessTypeId: data.BusinessTypeId,
    };
    const taxExists = this.taxList.find((tax) => {
      if (
        parseInt(tax.TaxValue?.toString()) ===
        parseInt(finalData.TaxValue?.toString())
      ) {
        this.addUpdateTaxSettingState.error = "tax_already_exists";
        return true;
      }
      return false;
    });

    if (taxExists) {
      toast.error(formatMessage("tax_already_exists"));
      return;
    }

    const url = URLConstants.MasterManagement + "/TaxType";
    this.addUpdateTaxSettingState.inProgress = true;
    return baseService
      .postRequest(url, finalData)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateTaxSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdateTaxSettingState.success = true;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.addUpdateTaxSettingState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateTaxSettingState.inProgress = false;
        })
      );
  };

  /**
   * This function is used to Updating Existing StoreManagement Details by calling an API.
   * @param id : The StoreManagement Identifier
   * @param data
   * @returns
   */
  UpdateTaxService = (id: number, data: any) => {
    const url = URLConstants.MasterManagement + "/TaxType";

    const finalData = {
      Id: id,
      TaxValue: data.TaxValue,
      Description: data.Description,
      IsTaxValueUpdated: data.IsTaxValueUpdated,
    };

    const taxExists = this.taxList.find((tax) => {
      if (
        parseInt(tax.TaxValue?.toString()) ===
        parseInt(finalData.TaxValue?.toString()) &&
        tax.Id !== id
      ) {
        this.addUpdateTaxSettingState.error = "tax_already_exists";
        return true;
      }
      return false;
    });

    if (taxExists) {
      toast.error(formatMessage("tax_already_exists"));
      return;
    }

    return baseService
      .putRequest(url, finalData)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateTaxSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdateTaxSettingState.success = true;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.addUpdateTaxSettingState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateTaxSettingState.inProgress = false;
        })
      );
  };

  GetTaxByIdService = (id: number) => {
    this.getByIdTaxSettingState.inProgress = true;
    let url = `${URLConstants.MasterManagement}/TaxType/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.getByIdTaxSettingState.error = response.data.Message;
        } else {
          let data = response.data.Data;
          this.taxSetting = {
            TaxValue: data.TaxValue,
            Id: data.Id,
            Description: data.Description,
          };
        }
      })
      .catch((err: string) => {
        this.getByIdTaxSettingState.error = err;
      })
      .finally(
        action(() => {
          this.getByIdTaxSettingState.inProgress = false;
        })
      );
  };

  get getTaxDetail(): ITaxState {
    if (this.taxSetting) {
      return {
        Id: this.taxSetting.Id || -1,
        TaxValue: this.taxSetting.TaxValue || "",
        Description: this.taxSetting.Description || "",
      };
    }
    return taxInitialState;
  }

  /*
    This function is used to reset all AddStoreManagement observables to their initial values.  
    */
  resetAddUpdateTaxSettingState = () => {
    this.addUpdateTaxSettingState.inProgress = false;
    this.addUpdateTaxSettingState.success = false;
    this.addUpdateTaxSettingState.error = "";
    this.taxSetting = taxInitialState;
  };

  resetGetByIdTaxSettingState = () => {
    this.getByIdTaxSettingState.inProgress = false;
    this.getByIdTaxSettingState.success = false;
    this.getByIdTaxSettingState.error = "";
    this.taxSetting = taxInitialState;
  };

  resetGetAllTaxSettingState = () => {
    this.taxSettingState.inProgress = false;
    this.taxSettingState.success = false;
    this.taxSettingState.error = "";
  };

  /**
   * This function is used to Delete StoreManagement by calling an API.
   * @param id : The StoreManagement Identifier
   * @returns
   */
  DeleteTaxService = (id: number) => {
    this.deleteTaxSettingState.inProgress = true;
    let url = `${URLConstants.MasterManagement}/TaxType/${id}`;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteTaxSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else this.deleteTaxSettingState.success = true;
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.deleteTaxSettingState.error = err;
      })
      .finally(
        action(() => {
          this.deleteTaxSettingState.inProgress = false;
        })
      );
  };

  resetdDeleteTaxSettingState = () => {
    this.deleteTaxSettingState.inProgress = false;
    this.deleteTaxSettingState.success = false;
    this.deleteTaxSettingState.error = "";
  };

  GetAllBusinessTypeListService = () => {
    this.businessTypeSettingState.inProgress = true;
    const url = URLConstants.MasterManagement + "/BuisnessType/All";
    return baseService
      .getRequest(url)
      .then(
        (response: IApiResponse<IApiSuccessResponse<IBusinessTypeVM[]>>) => {
          if (response.data.Error) {
            this.businessTypeSettingState.error = response.data.Message;
            toast.error(formatMessage(response.data.Message));
          } else {
            this.businessTypeSettingState.success = true;
            this.businessTypeList = response.data.Data;
            this.allBusinessType = response.data.Data;
          }
        }
      )
      .catch((err: string) => {
        this.businessTypeSettingState.error = err;
      })
      .finally(
        action(() => {
          this.businessTypeSettingState.inProgress = false;
        })
      );
  };

  /**
   * This function is used to map allBusinessTypeOptions to allGeneral List suitable for Grid Component.
   * @returns getAllBusinessTypeOptions
   */
  get getAllBusinessTypeList(): any[] {
    if (this.businessTypeList && this.businessTypeList?.length > 0)
      return [...this.businessTypeList];
    else return [];
  }

  AddBusinessTypeService = (data: any) => {
    let finalData = {
      TypeName: data.BusinessType,
      Description: data.Description,
    };
    const url = URLConstants.MasterManagement + "/BuisnessType";
    this.addUpdateBusinessTypeSettingState.inProgress = true;
    return baseService
      .postRequest(url, finalData)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateBusinessTypeSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdateBusinessTypeSettingState.success = true;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.addUpdateBusinessTypeSettingState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateBusinessTypeSettingState.inProgress = false;
        })
      );
  };

  /**
   * This function is used to Updating Existing StoreManagement Details by calling an API.
   * @param id : The StoreManagement Identifier
   * @param data
   * @returns
   */
  UpdateBusinessTypeService = (id: number, data: any) => {
    let finalData = {
      Id: data.Id,
      TypeName: data.BusinessType,
      Description: data.Description,
    };
    const url = URLConstants.MasterManagement + "/BuisnessType";
    this.addUpdateBusinessTypeSettingState.inProgress = true;
    return baseService
      .putRequest(url, finalData)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateBusinessTypeSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdateBusinessTypeSettingState.success = true;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.addUpdateBusinessTypeSettingState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateBusinessTypeSettingState.inProgress = false;
        })
      );
  };

  GetBusinessTypeByIdService = (id: number) => {
    this.getByIdBusinessTypeSettingState.inProgress = true;
    let url = `${URLConstants.MasterManagement}/BuisnessType/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.getByIdBusinessTypeSettingState.error = response.data.Message;
        } else {
          let data = response.data.Data;
          this.businessTypeSetting = {
            BusinessType: data.TypeName,
            Id: data.Id,
            Description: data.Description,
          };
        }
      })
      .catch((err: string) => {
        this.getByIdBusinessTypeSettingState.error = err;
      })
      .finally(
        action(() => {
          this.getByIdBusinessTypeSettingState.inProgress = false;
        })
      );
  };

  get getBusinessTypeDetail(): any {
    return this.businessTypeSetting;
  }

  /*
    This function is used to reset all AddStoreManagement observables to their initial values.  
    */
  resetAddUpdateBusinessTypeSettingState = () => {
    this.addUpdateBusinessTypeSettingState.inProgress = false;
    this.addUpdateBusinessTypeSettingState.success = false;
    this.addUpdateBusinessTypeSettingState.error = "";
  };

  resetGetByIdBusinessTypeSettingState = () => {
    this.getByIdBusinessTypeSettingState.inProgress = false;
    this.getByIdBusinessTypeSettingState.success = false;
    this.getByIdBusinessTypeSettingState.error = "";
    this.businessTypeSetting = businessTypeInitialState;
  };

  resetGetAllBusinessTypeSettingState = () => {
    this.businessTypeSettingState.inProgress = false;
    this.businessTypeSettingState.success = false;
    this.businessTypeSettingState.error = "";
  };

  /**
   * This function is used to Delete StoreManagement by calling an API.
   * @param id : The StoreManagement Identifier
   * @returns
   */
  DeleteBusinessTypeService = (id: number) => {
    this.deleteBusinessTypeSettingState.inProgress = true;
    let url = `${URLConstants.MasterManagement}/BuisnessType/${id}`;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteBusinessTypeSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else this.deleteBusinessTypeSettingState.success = true;
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.deleteBusinessTypeSettingState.error = err;
      })
      .finally(
        action(() => {
          this.deleteBusinessTypeSettingState.inProgress = false;
        })
      );
  };

  resetdDeleteBusinessTypeSettingState = () => {
    this.deleteBusinessTypeSettingState.inProgress = false;
    this.deleteBusinessTypeSettingState.success = false;
    this.deleteBusinessTypeSettingState.error = "";
  };
  /*
    This function is used to reset all AddStoreManagement observables to their initial values.  
    */
  resetDeleteStoreManagement = () => {
    this.deleteTimeSettingState.inProgress = false;
    this.deleteTimeSettingState.success = false;
    this.deleteTimeSettingState.error = "";
  };

  /*
    This function is used to reset all observables to their initial values.  
    */
  reset = () => {
    this.error = "";
    this.inProgress = false;
    this.allBusinessType = [];
  };

  /**
   * This function is used to reset all store observables to their initial values.
   * @returns
   */
  resetStore = () => {
    this.error = "";
    this.inProgress = false;
    this.allBusinessType = [];
  };

  GetAllMotivationService = () => {
    this.motivationSettingState.inProgress = true;
    const url =
      URLConstants.MasterManagement +
      "/StoreMotivation/All?BusinessTypeId=" +
      getBusinessTypeIdFromLocalStorage();
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IMotivationVM[]>>) => {
        if (response.data.Error) {
          this.motivationSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.motivationSettingState.success = true;
          this.motivationList = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.motivationSettingState.error = err;
      })
      .finally(
        action(() => {
          this.motivationSettingState.inProgress = false;
        })
      );
  };

  get getAllMotivationOptions(): IOption[] {
    const options: IOption[] = [
      {
        id: -1,
        value: "please_select",
        disabled: false,
      },
    ];
    if (this.motivationList && this.motivationList.length > 0)
      this.motivationList.map((motivation: IMotivationVM) => {
        options.push({
          id: motivation.Id,
          value: motivation.MotivationName,
          disabled: false,
        });
      });
    return options;
  }

  /**
   * This function is used to map allMotivationOptions to allGeneral List suitable for Grid Component.
   * @returns getAllMotivationOptions
   */
  get getAllMotivationList(): any[] {
    if (this.motivationList && this.motivationList.length > 0) {
      return this.motivationList.map((motivation) => ({
        ...motivation,
        MotivationName: motivation.MotivationName,
      }));
    }
    return [];
  }

  AddMotivationService = (data: any) => {
    let finalData = {
      MotivationName: data.MotivationName,
      Description: data.Description,
      BusinessTypeId: getBusinessTypeIdFromLocalStorage(),
    };

    // const motivationExists = this.motivationList.find((motivation) => {
    //   if ((motivation.MotivationName.toString().trim()).toLocaleLowerCase() === (finalData.MotivationName.toString().trim()).toLocaleLowerCase()) {
    //     this.addUpdateTaxSettingState.error = "motivation_already_exists";
    //     return true;
    //   }
    //   return false;
    // });

    // if (motivationExists) {
    //   toast.error(formatMessage("motivation_already_exists"));
    //   return
    // }

    const url = URLConstants.MasterManagement + "/StoreMotivation";
    this.addUpdateMotivationSettingState.inProgress = true;
    return baseService
      .postRequest(url, finalData)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateMotivationSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdateMotivationSettingState.success = true;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.addUpdateMotivationSettingState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateMotivationSettingState.inProgress = false;
        })
      );
  };

  /**
   * This function is used to Updating Existing Motivation Details by calling an API.
   * @param id : The StoreManagement Identifier
   * @param data
   * @returns
   */
  UpdateMotivationService = (id: number, data: any) => {
    const url = URLConstants.MasterManagement + "/StoreMotivation";
    const finalData = {
      Id: id,
      MotivationName: data.MotivationName,
      Description: data.Description,
      BusinessTypeId: getBusinessTypeIdFromLocalStorage(),
    };

    // const motivationExists = this.motivationList.find((motivation) => {
    //   if ((motivation.MotivationName.toString().trim()).toLocaleLowerCase() === (finalData.MotivationName.toString().trim()).toLocaleLowerCase() && motivation.Id !== id) {
    //     this.addUpdateTaxSettingState.error = "motivation_already_exists";
    //     return true;
    //   }
    //   return false;
    // });

    // if (motivationExists) {
    //   toast.error(formatMessage("motivation_already_exists"));
    //   return
    // }

    return baseService
      .putRequest(url, finalData)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateMotivationSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdateMotivationSettingState.success = true;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.addUpdateMotivationSettingState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateMotivationSettingState.inProgress = false;
        })
      );
  };

  GetMotivationByIdService = (id: number) => {
    this.getByIdMotivationSettingState.inProgress = true;
    let url = `${URLConstants.MasterManagement}/StoreMotivation/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.getByIdMotivationSettingState.error = response.data.Message;
        } else {
          let data = response.data.Data;
          this.motivationSetting = {
            MotivationName: data.MotivationName,
            Id: data.Id,
            Description: data.Description,
          };
        }
      })
      .catch((err: string) => {
        this.getByIdMotivationSettingState.error = err;
      })
      .finally(
        action(() => {
          this.getByIdMotivationSettingState.inProgress = false;
        })
      );
  };

  get getMotivationDetail(): IMotivationState {
    if (this.motivationSetting) {
      return {
        Id: this.motivationSetting.Id || -1,
        MotivationName: this.motivationSetting.MotivationName || "",
        Description: this.motivationSetting.Description || "",
      };
    }
    return motivationInitialState;
  }

  GetAllPaymentService = () => {
    this.paymentSettingState.inProgress = true;
    const url =
      URLConstants.PaymentManagement +
      "/All?BusinessTypeId=" +
      getBusinessTypeIdFromLocalStorage();
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IPaymentVM[]>>) => {
        if (response.data.Error) {
          this.paymentSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.paymentSettingState.success = true;
          this.paymentList = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.paymentSettingState.error = err;
      })
      .finally(
        action(() => {
          this.paymentSettingState.inProgress = false;
        })
      );
  };

  get getAllPaymentOptions(): IOption[] {
    const options: IOption[] = [
      {
        id: -1,
        value: "please_select",
        disabled: false,
      },
    ];
    if (this.paymentList && this.paymentList.length > 0)
      this.paymentList.map((payment: IPaymentVM) => {
        options.push({
          id: payment.Id,
          value: payment.Name,
          disabled: false,
        });
      });
    return options;
  }

  /**
   * This function is used to map allPaymentOptions to allGeneral List suitable for Grid Component.
   * @returns getAllPaymentOptions
   */
  get getAllPaymentList(): any[] {
    if (this.paymentList && this.paymentList.length > 0) {
      return this.paymentList.map((payment) => ({
        ...payment,
        Name: payment.Name,
      }));
    }
    return [];
  }
  AddPaymentService = (data: any) => {
    let finalData = {
      Name: data.Name,
      Description: data.Description,
      BusinessTypeId: getBusinessTypeIdFromLocalStorage(),
    };

    const paymentExists = this.paymentList.find((payment) => {
      if (
        payment.Name.toString().trim().toLocaleLowerCase() ===
        finalData.Name.toString().trim().toLocaleLowerCase()
      ) {
        this.addUpdateTaxSettingState.error = "payment_already_exists";
        return true;
      }
      return false;
    });

    if (paymentExists) {
      toast.error(formatMessage("payment_already_exists"));
      return;
    }

    const url = URLConstants.PaymentManagement;
    this.addUpdatePaymentSettingState.inProgress = true;
    return baseService
      .postRequest(url, finalData)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdatePaymentSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdatePaymentSettingState.success = true;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.addUpdatePaymentSettingState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdatePaymentSettingState.inProgress = false;
        })
      );
  };

  /**
   * This function is used to Updating Existing StoreManagement Details by calling an API.
   * @param id : The StoreManagement Identifier
   * @param data
   * @returns
   */
  UpdatePaymentService = (id: number, data: any) => {
    const url = URLConstants.PaymentManagement;

    const finalData = {
      Id: id,
      Name: data.Name,
      Description: data.Description,
      BusinessTypeId: getBusinessTypeIdFromLocalStorage(),
      IsNameUpdated: data.IsNameUpdated,
    };

    const paymentExists = this.paymentList.find((payment) => {
      if (
        payment.Name.toString().trim().toLocaleLowerCase() ===
          finalData.Name.toString().trim().toLocaleLowerCase() &&
        payment.Id !== id
      ) {
        this.addUpdateTaxSettingState.error = "payment_already_exists";
        return true;
      }
      return false;
    });

    if (paymentExists) {
      toast.error(formatMessage("payment_already_exists"));
      return;
    }

    return baseService
      .putRequest(url, finalData)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdatePaymentSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdatePaymentSettingState.success = true;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.addUpdatePaymentSettingState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdatePaymentSettingState.inProgress = false;
        })
      );
  };

  GetPaymentByIdService = (id: number) => {
    this.getByIdPaymentSettingState.inProgress = true;
    let url = `${URLConstants.PaymentManagement}/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.getByIdPaymentSettingState.error = response.data.Message;
        } else {
          let data = response.data.Data;
          this.paymentSetting = {
            Name: data.Name,
            Id: data.Id,
            Description: data.Description,
          };
        }
      })
      .catch((err: string) => {
        this.getByIdPaymentSettingState.error = err;
      })
      .finally(
        action(() => {
          this.getByIdPaymentSettingState.inProgress = false;
        })
      );
  };

  get getPaymentDetail(): IPaymentState {
    if (this.paymentSetting) {
      return {
        Id: this.paymentSetting.Id || -1,
        Name: this.paymentSetting.Name || "",
        Description: this.paymentSetting.Description || "",
      };
    }
    return paymentInitialState;
  }

  DeletePaymentService = (id: number) => {
    this.deletePaymentSettingState.inProgress = true;
    let url = `${URLConstants.PaymentManagement}/${id}`;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deletePaymentSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else this.deletePaymentSettingState.success = true;
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.deletePaymentSettingState.error = err;
      })
      .finally(
        action(() => {
          this.deletePaymentSettingState.inProgress = false;
        })
      );
  };

  resetdDeletePaymentSettingState = () => {
    this.deletePaymentSettingState.inProgress = false;
    this.deletePaymentSettingState.success = false;
    this.deletePaymentSettingState.error = "";
  };

  /*
    This function is used to reset all AddStoreManagement observables to their initial values.  
    */
  resetAddUpdatePaymentSettingState = () => {
    this.addUpdatePaymentSettingState.inProgress = false;
    this.addUpdatePaymentSettingState.success = false;
    this.addUpdatePaymentSettingState.error = "";
    this.paymentSetting = paymentInitialState;
  };

  resetGetByIdPaymentSettingState = () => {
    this.getByIdPaymentSettingState.inProgress = false;
    this.getByIdPaymentSettingState.success = false;
    this.getByIdPaymentSettingState.error = "";
    this.paymentSetting = paymentInitialState;
  };

  resetGetAllPaymentSettingState = () => {
    this.paymentSettingState.inProgress = false;
    this.paymentSettingState.success = false;
    this.paymentSettingState.error = "";
  };
  /*
    This function is used to reset all Motivation observables to their initial values.  
    */
  resetAddUpdateMotivationSettingState = () => {
    this.addUpdateMotivationSettingState.inProgress = false;
    this.addUpdateMotivationSettingState.success = false;
    this.addUpdateMotivationSettingState.error = "";
    this.motivationSetting = motivationInitialState;
  };

  resetGetByIdMotivationSettingState = () => {
    this.getByIdMotivationSettingState.inProgress = false;
    this.getByIdMotivationSettingState.success = false;
    this.getByIdMotivationSettingState.error = "";
    this.motivationSetting = motivationInitialState;
  };

  resetGetAllMotivationSettingState = () => {
    this.motivationSettingState.inProgress = false;
    this.motivationSettingState.success = false;
    this.motivationSettingState.error = "";
  };

  /**
   * This function is used to Delete motivations  by calling an API.
   * @param id : The StoreManagement Identifier
   * @returns
   */
  DeleteMotivationService = (id: number) => {
    this.deleteMotivationSettingState.inProgress = true;
    let url = `${URLConstants.MasterManagement}/StoreMotivation/${id}`;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteMotivationSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else this.deleteMotivationSettingState.success = true;
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.deleteMotivationSettingState.error = err;
      })
      .finally(
        action(() => {
          this.deleteMotivationSettingState.inProgress = false;
        })
      );
  };

  resetdDeleteMotivationSettingState = () => {
    this.deleteMotivationSettingState.inProgress = false;
    this.deleteMotivationSettingState.success = false;
    this.deleteMotivationSettingState.error = "";
  };
  /*
   Reservation settings method for add update and delete starts from here  
    */

  get getAllReservationSettings(): IReservationSettingVM[] {
    return this.reservationList.length > 0 ? [...this.reservationList] : [];
  }

  AddReservationSettingService = (
    data: any
  ): Promise<{ Id: number } | null> => {
    let finalData = {
      StoreId: data.StoreId,
      CancelationTime: data.CancelationTime,
      NewReservationTime: data.NewReservationTime,
      IntervalTime: data.IntervalTime,
      SeatAvailable: data.SeatAvailable,
      Precaution: data.Precaution,
      EmailNotifyToStore: data.EmailNotifyToStore,
      BusinessSettings: data.BusinessSettings ?? [],
      CalendarIntervalTime: data.CalendarIntervalTime,
    };
    const url = URLConstants.MasterManagement + "/ReservationSettings";
    this.addUpdateReservationSettingState.inProgress = true;

    return baseService
      .postRequest(url, finalData)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateReservationSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
          return null;
        } else {
          this.addUpdateReservationSettingState.success = true;
          return response.data.Data;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.addUpdateReservationSettingState.error = err;
        
        return null;
      })
      .finally(
        action(() => {
          this.addUpdateReservationSettingState.inProgress = false;
        })
      );
  };

  UpdateReservationSettingService = (
    id: number,
    data: IReservationSettingVM
  ) => {
    let finalData = {
      Id: id,
      StoreId: data.StoreId,
      CancelationTime: data.CancelationTime,
      NewReservationTime: data.NewReservationTime,
      IntervalTime: data.IntervalTime,
      SeatAvailable: data.SeatAvailable,
      CalendarIntervalTime: data.CalendarIntervalTime,
      IsUpdated: true,
      Precaution: data.Precaution,
      EmailNotifyToStore: data.EmailNotifyToStore,
      UpdateBusinessSettings: data.BusinessSettings ?? [],
    };

    const url = `${URLConstants.MasterManagement}/ReservationSettings`;

    this.addUpdateReservationSettingState.inProgress = true;

    return baseService
      .putRequest(url, finalData)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateReservationSettingState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdateReservationSettingState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdateReservationSettingState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.addUpdateReservationSettingState.inProgress = false;
        })
      );
  };

  GetReservationSettingByIdService = async (id: number) => {
    this.getByIdReservationSettingState.inProgress = true;
    this.reservationSetting = {
      Id: 0,
      StoreId: 0,
      CancelationTime: "",
      NewReservationTime: "",
      CalendarIntervalTime: -1,
      IntervalTime: "",
      SeatAvailable: "",
      Precaution: "",
      EmailNotifyToStore: false,
      BusinessSettings: [],
    };

    let url = `${URLConstants.MasterManagement}/ReservationSettings/${id}`;

    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.getByIdReservationSettingState.error = response.data.Message;
          this.disableAction = false;
          return null;
        } else {
          let data = response.data.Data;
          this.disableAction = false;
          this.reservationSettingBusinessVM = [...data?.BusinessVM];
          this.reservationSetting = {
            Id: data.Id,
            StoreId: data.StoreId,
            CancelationTime: data.CancelationTime,
            NewReservationTime: data.NewReservationTime,
            IntervalTime: data.IntervalTime,
            SeatAvailable: data.SeatAvailable,
            CalendarIntervalTime: data.CalendarIntervalTime,
            Precaution: data.Precaution,
            EmailNotifyToStore: data.EmailNotifyToStore,
            BusinessSettings: data.BusinessVM.map(
              (setting: IBusinessSettingVM) => ({
                WeekDays: setting.WeekDays,
                IsClosed: setting.IsClosed,
                OpenTime: setting.OpenTime,
                ClosedTime: setting.ClosedTime,
              })
            ),
          };
          return this.reservationSetting;
        }
      })
      .catch((err: string) => {
        this.getByIdReservationSettingState.error = err;
        this.disableAction = true;
        toast.error(formatMessage(err));
        return null;
      })
      .finally(
        action(() => {
          this.getByIdReservationSettingState.inProgress = false;
        })
      );
  };

  get getClosedDays() {
    if (this.reservationSetting.BusinessSettings?.length > 0) {
      return this.reservationSetting.BusinessSettings?.filter(
        (businessDay) => businessDay.IsClosed
      ).map((businessDay) => {
        return {
          WeekDays: businessDay.WeekDays,
          IsClosed: businessDay.IsClosed,
        };
      });
    } else {
      return [];
    }
  }

  get getReservationSettingDetail(): any | null {
    if (!this.reservationSetting) return null;
    return {
      StoreId: this.reservationSetting.StoreId ?? "",
      CancelationTime: this.reservationSetting.CancelationTime ?? 0,
      NewReservationTime: this.reservationSetting.NewReservationTime ?? 0,
      IntervalTime: this.reservationSetting.IntervalTime ?? -1,
      SeatAvailable: this.reservationSetting.SeatAvailable ?? 0,
      CalendarIntervalTime: this.reservationSetting.CalendarIntervalTime ?? -1,
      Precaution: this.reservationSetting.Precaution ?? "",
      EmailNotifyToStore: this.reservationSetting.EmailNotifyToStore ?? false,
      IsHoliday: this.reservationSetting?.BusinessSettings?.length > 0 ? this.reservationSetting?.BusinessSettings?.find((item)=> item.WeekDays == 8) ? this.reservationSetting?.BusinessSettings?.find((item)=> item.WeekDays == 8)?.IsClosed : false : false,
      BusinessSettings:
        Array.isArray(this.reservationSetting.BusinessSettings) &&
        this.reservationSetting.BusinessSettings?.length > 0
          ? this.reservationSetting.BusinessSettings?.filter(item => item.WeekDays !== 8)?.map(
              (setting: IBusinessSettingVM) => {
                return {
                  WeekDays: setting.WeekDays,
                  IsClosed: setting.IsClosed,
                  OpenTime: setting.OpenTime
                    ? dayjs(setting.OpenTime, "HH:mm:ss").format("HH:mm")
                    : "00:00",
                  ClosedTime: setting.ClosedTime
                    ? dayjs(setting.ClosedTime, "HH:mm:ss").format("HH:mm")
                    : "00:00",
                };
              }
            )
          : Array.from({ length: 8 }, (_, index) => ({
              WeekDays: index,
              IsClosed: false,
            OpenTime: "00:00",
            ClosedTime: "00:00",
            })),
    };
  }

  resetAddUpdateReservationSettingState = () => {
    this.addUpdateReservationSettingState.inProgress = false;
    this.addUpdateReservationSettingState.success = false;
    this.addUpdateReservationSettingState.error = "";
  };

  resetGetByIdReservationSettingState = () => {
    this.getByIdReservationSettingState.inProgress = false;
    this.getByIdReservationSettingState.success = false;
    this.getByIdReservationSettingState.error = "";
    this.reservationSetting = reservationSettingInitialState;
    this.reservationSettingBusinessVM = [];
  };

  /**
   * This function is used to map allConsuptionTaxOptions to allGeneral List suitable for Grid Component.
   * @returns getAllBusinessTypeOptions
   */
  get getAllConsumptionTaxList(): any[] {
    if (this.consumptionTaxList && this.consumptionTaxList?.length > 0)
      return [...this.consumptionTaxList];
    else return [];
  }

  AddConsumptionTaxService = (data: any) => {
    let finalData = {
      TaxValue: data.TaxValue,
      HeadquarterId: data.HeadquarterId,
    };
    const url = URLConstants.MasterManagement + "/ConsumptionTax";
    this.addUpdateConsumptionTaxState.inProgress = true;
    return baseService
      .postRequest(url, finalData)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateConsumptionTaxState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdateConsumptionTaxState.success = true;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.addUpdateConsumptionTaxState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateConsumptionTaxState.inProgress = false;
        })
      );
  };

  /**
   * This function is used to Updating Existing ConsuptionTax Details by calling an API.
   * @param id : The StoreManagement Identifier
   * @param data
   * @returns
   */
  UpdateConsumptionTaxService = (id: number, data: any) => {
    let finalData = {
      Id: data.Id,
      TaxValue: data.TaxValue,
      HeadquarterId: data.HeadquarterId,
    };
    const url = URLConstants.MasterManagement + "/ConsumptionTax";
    this.addUpdateConsumptionTaxState.inProgress = true;
    return baseService
      .putRequest(url, finalData)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateConsumptionTaxState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdateConsumptionTaxState.success = true;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.addUpdateConsumptionTaxState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateConsumptionTaxState.inProgress = false;
        })
      );
  };

  GetConsumptionTaxByHeadquarterIdService = (id: number) => {
    this.getByIdConsumptionTaxState.inProgress = true;
    let url = `${URLConstants.MasterManagement}/ConsumptionTax/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.getByIdConsumptionTaxState.error = response.data.Message;
          this.disableAction = false;
        } else {
          this.disableAction = false;
          let data = response.data.Data;
          this.consumptioTaxSetting = {
            TaxValue: data.TaxValue,
            Id: data.Id,
            HeadquarterId: data.HeadquarterId,
          };
        }
      })
      .catch((err: string) => {
        this.getByIdConsumptionTaxState.error = err;
        toast.error(formatMessage(err))
        this.disableAction = true;
      })
      .finally(
        action(() => {
          this.getByIdConsumptionTaxState.inProgress = false;
        })
      );
  };

  get getConsumptionTaxDetail(): IConsumptionTaxState {
    if (this.consumptioTaxSetting?.Id && this.consumptioTaxSetting.Id > 0) {
      return this.consumptioTaxSetting;
    }
    return consumptionTaxInitialState;
  }

  resetAddUpdateConsumptionTaxState = () => {
    this.addUpdateConsumptionTaxState = { ...this.initialStateValue };
  };
  resetConsumptionTaxSetting = () => {
    this.consumptioTaxSetting = { ...consumptionTaxInitialState };
  };

  // Store motivation settings starts from here for store
  AddStoreMotivation = (data: { MotiveId: number; StoreId: number }) => {
    const url = `${URLConstants.MasterManagement}/MotivationInStore`;
    this.addUpdateMotivationInStoreState.inProgress = true;
    return baseService
      .postRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdateMotivationInStoreState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdateMotivationInStoreState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdateMotivationInStoreState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.addUpdateMotivationInStoreState.inProgress = false;
        })
      );
  };

  DeleteStoreMotivation = (id: number) => {
    const url = `${URLConstants.MasterManagement}/MotivationInStore/${id}`;
    this.deleteMotivationInStoreState.inProgress = true;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.deleteMotivationInStoreState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.deleteMotivationInStoreState.success = true;
        }
      })
      .catch((err: string) => {
        this.deleteMotivationInStoreState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.deleteMotivationInStoreState.inProgress = false;
        })
      );
  };

  GetStoreMotivationByStoreId = (id: number) => {
    const url = `${URLConstants.MasterManagement}/MotivationInStore/${id}`;
    this.getByIdMotivationInStoreState.inProgress = true;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.getByIdMotivationInStoreState.error = response.data.Message;
        } else {
          const data = response.data.Data;
          this.motivationInStoreList = data.MotivationInStoreList || [];
        }
      })
      .catch((err: string) => {
        this.getByIdMotivationInStoreState.error = err;
      })
      .finally(
        action(() => {
          this.getByIdMotivationInStoreState.inProgress = false;
        })
      );
  };

  get getMotivationInStoreOptions(): IOption[] {
    const options: IOption[] = [
      {
        id: -1,
        value: "please_select",
        disabled: false,
      },
    ];

    if (this.motivationInStoreList && this.motivationInStoreList.length > 0) {
      this.motivationInStoreList.forEach((item) => {
        if (item.IsUsed && item.StoreMotivation) {
          options.push({
            id: item.StoreMotivation.Id,
            value: item.StoreMotivation.MotivationName,
            disabled: false,
          });
        }
      });
    }

    return options;
  }

  get getMotivationInStore() {
    return this.motivationInStore;
  }
  resetdDeleteMotivationInStoregState = () => {
    this.deleteMotivationInStoreState.inProgress = false;
    this.deleteMotivationInStoreState.success = false;
    this.deleteMotivationInStoreState.error = "";
  };
  resetAddUpdateMotivationInStoreState = () => {
    this.addUpdateMotivationInStoreState.inProgress = false;
    this.addUpdateMotivationInStoreState.success = false;
    this.addUpdateMotivationInStoreState.error = "";
    this.motivationInStore = motivationInStoreInitialState;
  };

  // payment in store methods start from here
  AddStorePayment = (data: { PaymentModeId: number; StoreId: number }) => {
    const url = `${URLConstants.PaymentManagement}/Store`;
    this.addUpdatePaymentInStoreState.inProgress = true;
    return baseService
      .postRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.addUpdatePaymentInStoreState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdatePaymentInStoreState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdatePaymentInStoreState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.addUpdatePaymentInStoreState.inProgress = false;
        })
      );
  };

  DeleteStorePayment = (id: number) => {
    const url = `${URLConstants.PaymentManagement}/Store/${id}`;
    this.deletePaymentInStoreState.inProgress = true;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.deletePaymentInStoreState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.deletePaymentInStoreState.success = true;
        }
      })
      .catch((err: string) => {
        this.deletePaymentInStoreState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.deletePaymentInStoreState.inProgress = false;
        })
      );
  };

  GetStorePaymentByStoreId = (storeId: number) => {
    const url = `${
      URLConstants.PaymentManagement
    }/Store/All/${storeId}?BusinessTypeId=${getBusinessTypeIdFromLocalStorage()}`;
    this.getByIdPaymentInStoreState.inProgress = true;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.getByIdPaymentInStoreState.error = response.data.Message;
        } else {
          const data = response.data.Data;
          this.paymentInStoreList = data.StorePaymentModeList;
        }
      })
      .catch((err: string) => {
        this.getByIdPaymentInStoreState.error = err;
      })
      .finally(
        action(() => {
          this.getByIdPaymentInStoreState.inProgress = false;
        })
      );
  };

  get getPaymentInStore() {
    return this.paymentInStore;
  }

  get PaymentInStoreDetails() {
    return this.paymentInStoreList.map((payment) => ({
      Id: payment.Id,
      StoreId: payment.StoreId,
      IsUsed: payment.IsUsed,
      PaymentMode: payment.PaymentMode,
      PaymentModeId: payment.PaymentMode.Id,
      PaymentName: payment.PaymentMode.Name,
      Description: payment.PaymentMode.Description,
    }));
  }

  get PaymentThatAreUsedInStoreDetails() {
    if (!this.paymentInStoreList?.length) return [];

    return this.paymentInStoreList
      .filter((payment) => payment.IsUsed)
      .map((payment) => ({
        Id: payment.Id,
        StoreId: payment.StoreId,
        IsUsed: payment.IsUsed,
        PaymentMode: payment.PaymentMode,
        PaymentModeId: payment.PaymentMode?.Id,
        PaymentName: payment.PaymentMode?.Name,
        Description: payment.PaymentMode?.Description,
      }));
  }

  GetSMRPaymentDetailsBySaleRecordId = (storeId: number) => {
    const url = `${URLConstants.GetSMRPaymentDetailsBySaleRecordId}?SaleRecordId=${storeId}`;
    this.paymentDetailBySaleRecordIdState.inProgress = true;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.paymentDetailBySaleRecordIdState.error = response.data.Message;
        } else {
          const data = response.data.Data;
          this.paymentDetailBySaleRecordId = {
            ...data,
            StoreSeletedPayments: [],
          };
        }
      })
      .catch((err: string) => {
        this.paymentDetailBySaleRecordIdState.error = err;
      })
      .finally(
        action(() => {
          this.paymentDetailBySaleRecordIdState.inProgress = false;
        })
      );
  };

  resetPaymentDetailBySaleRecordIdState = () => {
    this.paymentDetailBySaleRecordIdState = { ...this.initialStateValue };
    this.paymentDetailBySaleRecordId = {
      Total: 0,
      ConsumptionTax: 0,
      PaymentDetailsVMs: [],
      StoreSeletedPayments: [],
    };
  };

  get storeSeletedPaymentModesForSMR(): IPaymentSMRVM {
    return {
      ...this.paymentDetailBySaleRecordId,
      StoreSeletedPayments: this.paymentInStoreList
        .filter((payment) => payment.IsUsed === true)
        ?.map((payment) => {
          let paidMethodItem: IPaymentDetailsVMs[] = [];
          if (
            this.paymentDetailBySaleRecordId?.PaymentDetailsVMs &&
            this.paymentDetailBySaleRecordId.PaymentDetailsVMs.length > 0
          )
            paidMethodItem =
              this.paymentDetailBySaleRecordId.PaymentDetailsVMs?.filter(
                (item) => item.PaymentModeId === payment.Id
              );
          return {
            Id: payment.Id,
            PaymentModeId: payment.PaymentMode.Id,
            Name: payment.PaymentMode.Name,
            Amount: paidMethodItem.length > 0 ? paidMethodItem[0]?.Amount : 0,
            IsSelected: paidMethodItem.length > 0,
          };
        }),
    };
  }

  resetdDeletePaymentInStoregState = () => {
    this.deletePaymentInStoreState.inProgress = false;
    this.deletePaymentInStoreState.success = false;
    this.deletePaymentInStoreState.error = "";
  };
  resetAddUpdatePaymentInStoreState = () => {
    this.addUpdatePaymentInStoreState.inProgress = false;
    this.addUpdatePaymentInStoreState.success = false;
    this.addUpdatePaymentInStoreState.error = "";
    this.paymentInStore = paymnetInStoreInitialState;
  };

  GetReservationSettingMinMaxTime = (id: number) => {
    this.reservationSettingMinMaxState.inProgress = true;
    let url = `${URLConstants.GetReservationSettingMinMax}?storeId=${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.reservationSettingMinMaxState.error = response.data.Message;
        } else {
          let data = response.data.Data;
          this.reservationSettingMinMax = data;
        }
      })
      .catch((err: string) => {
        this.reservationSettingMinMaxState.error = err;
      })
      .finally(
        action(() => {
          this.reservationSettingMinMaxState.inProgress = false;
        })
      );
  };

  get getReservationSettingMinMaxDetail(): any {
    if (this.reservationSettingMinMax) {
      return {
        MinTime: this.reservationSettingMinMax?.MinTime,
        MaxTime: this.reservationSettingMinMax?.MaxTime,
      };
    }
    return {
      MinTime: "00:00",
      MaxTime: "00:00",
    };
  }

  resetReservationSettingMinMaxState = () => {
    this.reservationSettingMinMaxState = { ...this.initialStateValue };
  };

  GetMiscellaneousSettingByKeyService = (key: string) => {
    this.getMiscellaneousSettingByKeyState.inProgress = true;
    let url = `${URLConstants.MiscellaneousSetting}?key=${key}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IMiscellaneousSettingVM>>) => {
        if (response.data.Error) {
          this.getMiscellaneousSettingByKeyState.error = response.data.Message;
        } else {
          let data = response.data.Data;
          this.getMiscellaneousSettingByKey = data;
        }
      })
      .catch((err: string) => {
        this.getMiscellaneousSettingByKeyState.error = err;
      })
      .finally(
        action(() => {
          this.getMiscellaneousSettingByKeyState.inProgress = false;
        })
      );
  };

  get getMiscellaneousSettingByKeyDetail(): boolean {
    if (this.getMiscellaneousSettingByKey) {
      return this.getMiscellaneousSettingByKey.Value 
    }
    return false;
  }

  resetGetMiscellaneousSettingByKeyState = () => {
    this.getMiscellaneousSettingByKeyState = { ...this.initialStateValue };
    this.getMiscellaneousSettingByKey = undefined;
  };

  /**
   * This function is used to Updating Existing Miscellaneous Setting Details by calling an API.
   * @param Key : The Key Identifier
   * @param value
   * @returns
   */
  UpdateMiscellaneousSettingService = (key: string, value: boolean) => {
    this.updateMiscellaneousSettingByKeyState.inProgress = true;
    const url = URLConstants.MiscellaneousSetting;
    const requestBody = {
      Key: key,
      Value: value,
    };
    return baseService
      .putRequest(url, requestBody)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.updateMiscellaneousSettingByKeyState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.updateMiscellaneousSettingByKeyState.success = true;
        }
      })
      .catch((err: string) => {
        toast.error(formatMessage(err));
        this.updateMiscellaneousSettingByKeyState.error = err;
      })
      .finally(
        action(() => {
          this.updateMiscellaneousSettingByKeyState.inProgress = false;
        })
      );
    };
  
  resetUpdateMiscellaneousSettingByKeyState = () => {
    this.updateMiscellaneousSettingByKeyState = { ...this.initialStateValue };
  };

  setDisableAction = (acionStatus: boolean) =>{
    this.disableAction = acionStatus;
  }

}

export default new MasterManagementStore();
